import React from "react";
import cn from "../../lib/cn";
import P from "../../shared/typography/P";

const Instruction = ({ className }) => {
    return (
        <div
            className={cn(
                "flex flex-col md:border md:w-[50%] xl:w-[50%] rounded-t-2.5 bg-white   md:rounded-3xl shadow-md p-1",
                className
            )}
        >
            <div className=" bg-gray-200 p-1 text-center rounded-xl mb-3 ">
                <P className="lg:text-lg xl:text-lg">
                    Feasibility Survey Process
                </P>
            </div>
            <ul className="ml-3 mb-4">
                <P className="flex flex-col gap-1 font-light">
                    <li className="list-disc">
                        Customer will book feasibility survey on the portal
                    </li>
                    <li className="list-disc">
                        Our team will visit your site and perform following
                        checks
                        <li className="list-disc list-inside">
                            Total shade free area available
                        </li>
                        <li className="list-disc list-inside">
                            Perform shadow analysis
                        </li>
                    </li>
                </P>
            </ul>
            <div className=" bg-gray-200 p-1   text-center rounded-xl mb-3 ">
                <P className="lg:text-lg xl:text-lg">
                    Required data from your ends
                </P>
            </div>
            <ul className="ml-3">
                <P className="flex flex-col gap-1 font-light">
                    <li className="list-disc">Your recent electricity bill</li>
                    <li className="list-disc">
                        Ask for your preferences and requirements
                    </li>
                </P>
            </ul>

            <div className="bg-primary p-2 rounded-2xl mt-2">
                <P className="text-white">
                    Based on your preferences, will design your solar plant and
                    shared proposal
                </P>
            </div>
        </div>
    );
};

export default Instruction;
